export const LANDING = '/';
export const HOME = '/home';
export const FORM_CONTAINER = '/complaint-form';
export const EDIT_PROFILE = '/edit-profile';
export const PROFILE = '/profile';
export const TWEET_CONFIRM = '/tweet-confirmation';
export const SIGN_IN = '/login';
export const SIGN_UP = '/login2';
